import React, { useEffect, useState } from "react";
import "./InternalTransfer.css";

const API_URL = "https://server.majestyfx.com/admin_transfer.php";

const InternalTransfers = () => {
  const [statusFilter, setStatusFilter] = useState("all");
const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");

  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setError("");
        const res = await fetch(API_URL, { headers: { Accept: "application/json" } });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        setRows(Array.isArray(json?.data) ? json.data : []);
      } catch (e) {
        setError(e?.message || "Failed to load transfers");
        setRows([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);
const filteredRows = rows.filter((r) => {
  const q = search.toLowerCase();

  const matchesSearch =
    String(r.client || "").toLowerCase().includes(q) ||
    String(r.trade_from || "").toLowerCase().includes(q) ||
    String(r.trade_to || "").toLowerCase().includes(q) ||
    String(r.ticket_from || "").toLowerCase().includes(q) ||
    String(r.ticket_to || "").toLowerCase().includes(q) ||
    String(r.status || "").toLowerCase().includes(q);

  const matchesStatus =
    statusFilter === "all" ||
    String(r.status || "").toLowerCase() === statusFilter;

  const rowDate = r.datetime ? new Date(r.datetime) : null;
  const from = fromDate ? new Date(fromDate) : null;
  const to = toDate ? new Date(toDate + "T23:59:59") : null;

  const matchesDate =
    (!from || (rowDate && rowDate >= from)) &&
    (!to || (rowDate && rowDate <= to));

  return matchesSearch && matchesStatus && matchesDate;
});

  const fmtNum = (n) =>
    typeof n === "number" ? n.toLocaleString(undefined, { maximumFractionDigits: 2 }) : n ?? "-";

  return (
    <div className="dashboard-container">
      <main className="main-content">
        {/* Header row: Title + Breadcrumb */}
        <div className="header-row">
          <h1 className="page-title">Internal Transfers</h1>
          <div className="breadcrumb">
            <span className="breadcrumb-link">Home</span>
            <span className="breadcrumb-separator">/</span>
            <span>Internal Transfers</span>
          </div>
        </div>

        {/* Subtitle */}
        <p className="subtitle">View All Internal Transfers Transactions</p>

        {/* Search & Buttons */}
        <div className="action-row">
<input
  type="text"
  placeholder="Search by client, trading account, ticket..."
  value={search}
  onChange={(e) => setSearch(e.target.value)}
/>
<button
  className="btn"
  onClick={() => {
    setSearch("");
    setStatusFilter("all");
    setFromDate("");
    setToDate("");
  }}
>
  Reset Filters
</button>
          <button className="btn">Export to Excel</button>
        </div>

        {/* Filters */}
       <div className="filters">
  <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
    <option value="all">All</option>
    <option value="approved">Approved</option>
    <option value="pending">Pending</option>
    <option value="rejected">Rejected</option>
  </select>

  <input
    type="date"
    value={fromDate}
    onChange={(e) => setFromDate(e.target.value)}
  />

  <input
    type="date"
    value={toDate}
    onChange={(e) => setToDate(e.target.value)}
  />
</div>


        {/* Table */}
        <div className="table-container">
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Date & Time</th>
                <th>Client</th>
                <th>Trading Account #</th>
                <th>Notes</th>
                <th>Transfer In</th>
                <th>Transfer Out</th>
                <th>Ticket</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10" style={{ textAlign: "center" }}>Loading…</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="10" style={{ textAlign: "center", color: "crimson" }}>
                    Error: {error}
                  </td>
                </tr>
              ) : rows.length === 0 ? (
                <tr>
                  <td colSpan="10" style={{ textAlign: "center" }}>No data available</td>
                </tr>
              ) : (
                filteredRows.map((r, idx) => (
                  <tr key={r.id ?? idx}>
                    <td>{idx + 1}</td>
                    <td>{r.datetime}</td>
                    <td>{r.client || "-"}</td>
                    <td>{`${r.trade_from || "-"} → ${r.trade_to || "-"}`}</td>
                    <td>{r.notes || "-"}</td>
                    {/* For an internal transfer, the same amount moves out of one and into another */}
                    <td>{fmtNum(r.amount)}</td>
                    <td>{fmtNum(r.amount)}</td>
                    <td>{`${r.ticket_from ?? "-"} / ${r.ticket_to ?? "-"}`}</td>
                    <td>{r.status || "-"}</td>
                    <td>-</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
</div>
        {/* Footer */}
        <footer className="footer">
          <p>
            Copyright © 2025 <span className="brand">Majesty Fx</span>. All
            rights reserved.
          </p>
          <span className="version">Version 2.0</span>
        </footer>
      </main>
    </div>
  );
};

export default InternalTransfers;
